<template>
  <div
      class="flex flex-col flex-1 min-h-0"
      style="--viva-navbar-height: 6rem; --viva-navbar-action-gap: 1rem;"
  >
    <TheHeader :show-logo="true"/>
    <div class="flex flex-col flex-1 min-w-0 w-full max-w-none bg-black p-6 pb-36 children:grow-1 text-gray-100 overflow-x-clip">
      <slot/>
    </div>
    <TheNavbar/>
  </div>
</template>

<script lang="ts" setup>

const backwardTitle = useState<string>('backwardTitle')
const backwardName = useState<string>('backwardName')
const backwardTo = useState<any>('backwardTo')
backwardName.value = ''
backwardTo.value = null
</script>
